<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="$localStorageService.can('DX_14_ver_porcentaje') || $localStorageService.can('DX_13_ver_porcentaje') ">
      {{data.item.porcentaje}} %
      <b-progress :value="data.item.porcentaje " :max="max" show-progress animated
                  :variant="
            data.item.porcentaje <= 100 && data.item.porcentaje >= 41  ? 'danger' :
            data.item.porcentaje <= 40  && data.item.porcentaje >= 25  ? 'warning' :
            data.item.porcentaje <= 24  && data.item.porcentaje >= 11  ? 'info' :
            data.item.porcentaje <= 10  && data.item.porcentaje >= 1   ? 'success' : 'secondary'
        "
      >
      </b-progress>
    </div>
  </div>

</template>

<script>
export default {
    name: "BandejaPorcentajeComponente",
    props: {
        data: Object
    },
    methods: {

    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        max: 100,
    }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>
